import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { LineService } from '@/infra/services/line';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

interface GetLinesParams {
	organization_id: string;
	company_id: string;
	sector_id: string;
}

const Service = LineService.getInstance();

export const useGetLines = (params: GetLinesParams) => {
	return useQuery<SelectOption[]>({
		queryKey: [QUERY_KEYS.GET_LINES, params],
		queryFn: async () => Service.getLines(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.sector_id
	});
};
